import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonService } from 'src/app/shared/services/common.service';
import { StorageService } from 'src/app/core/cache/storage.service';
import { IUserDetailsResponse } from 'src/app/shared/interfaces/user-details.interface';
import { Constants } from 'src/app/shared/utilities/constants';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
})
export class DashboardComponent {
  code: string;

  constructor(
    private readonly route: ActivatedRoute,
    private readonly commonService: CommonService,
    private readonly storageService: StorageService,
    private readonly router: Router,
  ) {}

  ngOnInit() {
    this.code = this.route.snapshot?.queryParams['code'];
    const IdToken = this.storageService.getAccessToken();
    if (IdToken) {
      this.router.navigate(['home']);
    } else if (this.code) {
      this.loginAndSaveInfo(this.code);
    } else {
      this.commonService.resetAndNavigateToLogin();
    }
  }

  loginAndSaveInfo(code: string): void {
    const payload = {
      code: code,
      redirectUrl: this.commonService.encodeData(environment.REDIRECT_URL),
    };
    this.commonService.loginAndSaveInfo(payload).subscribe({
      next: (response: IUserDetailsResponse) => {
        if (!response.error && response.data?.idToken) {
          this.storageService.setItem(
            Constants.STORAGE_KEYS.API_KEY, //used somewhere
            response.data['apiKey'],
          );
          this.storageService.setItem(
            Constants.STORAGE_KEYS.REFRESH_TOKEN,
            response.data['refreshToken'],
          );
          this.storageService.setItem(
            Constants.STORAGE_KEYS.ID_TOKEN,
            response.data.idToken,
          );
          this.storageService.setItem(
            Constants.STORAGE_KEYS.VALID_UPTO,
            response.data.validUpto,
          );
          this.storageService.setItem(Constants.STORAGE_KEYS.USER_DATA, {
            emailId: response.data.emailId,
            firstName: response.data.firstName,
            lastName: response.data.lastName,
          });
          this.router.navigate(['home']);
        } else {
          this.commonService.showErrorMessage(
            response.errors?.[0]?.errorMessage || 'An error occurred',
          );
          this.commonService.resetAndNavigateToLogin();
        }
      },
      error: (error) => {
        this.commonService.showError(error);
        this.commonService.resetAndNavigateToLogin();
      },
    });
  }
}
